"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LandscapeOnly = LandscapeOnly;
const jsx_runtime_1 = require("react/jsx-runtime");
const viewport_1 = require("../lib/viewport");
const icon_1 = require("./icon");
/**
 * ┌───────────────────────────────────────────────────────────────────────────┐
 * │ 17 Oct 2026 · A table that only reads sideways.                           │
 * └───────────────────────────────────────────────────────────────────────────┘
 *
 * The timesheet, Logolás and Erőforrás are people × days grids: upright on a phone they show a
 * name column and one day. The product owner: they show only in landscape, and upright they say so.
 *
 * ⚠️ **A page cannot turn the screen** — `screen.orientation.lock` works only for an installed,
 * fullscreen app — so the notice asks, and the table appears the moment the phone is turned
 * (`usePortraitPhone` follows the viewport). Off a phone it is always the table.
 */
function LandscapeOnly({ message, children, }) {
    if (!(0, viewport_1.usePortraitPhone)())
        return children;
    return ((0, jsx_runtime_1.jsxs)("div", { role: "status", className: "text-muted-foreground flex min-h-0 flex-1 flex-col items-center justify-center gap-3 p-8 text-center", children: [(0, jsx_runtime_1.jsx)(icon_1.Icon, { name: "smartphone", size: 28, className: "rotate-90 opacity-70" }), (0, jsx_runtime_1.jsx)("span", { className: "max-w-[260px] text-[13px] leading-relaxed", children: message })] }));
}
//# sourceMappingURL=landscape-only.js.map